import {
  HttpRequestModelType,
  HttpRequestStatus,
  __HttpRequestModel__,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addIssueStrategy } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { createIssueModelToOutDto } from '../../../../shared/domain/issue/mapping/toOut/createIssueModelToOutDto';
import { AddIssueUseCase } from '../../../../shared/domain/issue/types';
import type { IssueRequestData } from './issueRequestData';

function makeAddIssueUseCase(
  addIssueStrategy: (
    httpRequestEntity: __HttpRequestModel__
  ) => Promise<any>
): AddIssueUseCase {
  return function addIssue(createIssueModel, uniqueId): Promise<void> {
    debugLog('addIssue', createIssueModel);
    const data: IssueRequestData = {
      body: createIssueModelToOutDto(createIssueModel),
      uniqueId,
    };

    return addIssueStrategy({
      createdAt: Date.now(),
      method: 'POST',
      url: `project/${createIssueModel.projectId}/issue`,
      data,
      entityType: HttpRequestModelType.issue,
      status: HttpRequestStatus.NEW,
    });
  };
}

const addIssue = makeAddIssueUseCase(addIssueStrategy);
export default addIssue;
